<template>
	<div class="p-x-20 p-y-20 border-bottom">
		<div class="f-bold f-16 f-c-black">
			Input Radio - SOInputRadio
		</div>
		<SOInputRadio
			:selected-radio="JSON.stringify(input.radio.selectedRadio)"
			:v2="true"
			:radios="input.radio.radioData.data"
			@selected="(val) => { input.radio.selectedRadio = val }"
		/>
		<div class="p-t-12">
			<div class="f-semi f-14 f-c-black">Attribut v-bind:</div>
			<div class="f-regular f-12 f-c-midgrey">
				<div v-for="(val, key) in input.radio" :key="`input-radio-${key}`" class="p-d-4">
					<div><b>v-bind:{{ key }}</b></div>
					<input v-if="typeof val !== 'object'" type="text" v-model="input.radio[key]">
					<div v-else>{{ val }}</div>
				</div>
			</div>
		</div>
		<div class="p-t-12">
			<div class="f-semi f-14 f-c-black">Attribut v-on:</div>
			<div class="f-reguler f-12 f-c-midgrey">
				<b>v-on:selected</b>
				<pre>(val) => { input.radio.selectedRadio = val }</pre>
			</div>
		</div>
	</div>
</template>

<script>
import SOInputRadio from "@/so-components/global/input/SOInputRadio";

export default {
	name: "PlaygroundRadio",
	components: {
		SOInputRadio
	},
	data() {
		return {
			input: {
				radio: {
					selectedRadio: {},
					radioData: {
						name: "",
						data: [
							{
								id: "r1",
								value: "r1",
								label: "radio 1"
							},
							{
								id: "r2",
								value: "r2",
								label: "radio 2"
							},
							{
								id: "r3",
								value: "r3",
								label: "radio 3"
							},
							{
								id: "r4",
								value: "r4",
								label: "radio 4"
							}
						]
					}
				}
			}
		}
	}
}
</script>